module.exports = __webpack_public_path__ + "static/img/pw_ex_logo.b7aa83a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/pw_ex_logo.png
// module id = zukd
// module chunks = 2